import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import CustomAvatar from '../../CustomAvatar'

import './style.scss'

interface ContactPartnerProps {
    name?: string | null
    image?: string | null
    /** Zusammenhang statt Wiederholung: "ueber die Talent Card X", eine Uhrzeit. */
    subline?: string | null
    size?: number
    className?: string
}

/**
 * Ein Gesicht mit Namen. Anfragenliste, Chat-Kopf und Composer zeigen dieselbe
 * Zeile, damit derselbe Mensch ueberall gleich aussieht.
 */
const ContactPartner: React.FC<ContactPartnerProps> = ({
    name,
    image,
    subline,
    size = 40,
    className,
}) => {
    const { t } = useTranslation()

    return (
        <div
            className={clsx('contact-partner', className)}
        >
            <CustomAvatar
                width={size}
                type='round'
                img={image}
                alt={name ?? undefined}
            />
            <div
                className='contact-partner__text'
            >
                <div
                    className='contact-partner__name'
                >
                    {name ?? t('contact.partner.unknown', 'Unbekannt')}
                </div>
                {subline && (
                    <div
                        className='contact-partner__subline'
                    >
                        {subline}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ContactPartner
